import React from "react";
import NotFound from "../Screens/Common/NotFound";
import Home from "../Screens/User/Home";
import About from "../Screens/User/About";
import Contact from "../Screens/User/Contact";
import Services from "../Screens/User/Services";
import Blogs from "../Screens/User/Blogs";
import Offers from "../Screens/User/Offers";

const userRoutes = [
  { path: "/", component: <Home /> },
  { path: "/about", component: <About /> },
  { path: "/services", component: <Services /> },
  { path: "/offers", component: <Offers /> },
  { path: "/contact", component: <Contact /> },
  { path: "*", component: <NotFound /> },
];

export { userRoutes };
